module.exports = __webpack_public_path__ + "static/media/Helen.97a7c3c0.jpg";